/// <reference path="type.type.ts" />

import AxelType from './type.type';

export default class AxelDate extends AxelType {
  constructor(value) {
    super(value);

    const computedValue = this.computeValue(value);

    if (computedValue.getTime && !isNaN(computedValue.getTime())) {
      this._newValue = computedValue;
    } else {
      this.setAsDirty();
    }
  }

  private computeValue(value) {
    let result;

    if (!isNaN(Number(value))) {
      // try to parse epoch
      // @see http://stackoverflow.com/a/8016205
      result = new Date(parseInt(value) * 1000);
    } else {
      result = new Date(value);
    }
    return result;
  }
}
